import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Building2, Users, Briefcase } from "lucide-react";
import MeetingSchedulingForm from "@/components/MeetingSchedulingForm";


import { useLanguage } from "@/hooks/useLanguage";

const Contact = () => {
  const [isMeetingFormOpen, setIsMeetingFormOpen] = useState(false);
  const { t } = useLanguage();
  
  const contactTypes = [
    {
      icon: Building2,
      title: t('contact.investment.title'),
      description: t('contact.investment.description'),
      email: "investments@brassbellhospitality.com",
      cta: t('contact.investment.cta')
    },
    {
      icon: Users,
      title: t('contact.business.title'),
      description: t('contact.business.description'),
      email: "business@brassbellhospitality.com", 
      cta: t('contact.business.cta')
    },
    {
      icon: Briefcase,
      title: t('contact.technology.title'),
      description: t('contact.technology.description'),
      email: "technology@brassbellhospitality.com",
      cta: t('contact.technology.cta')
    }
  ];

  return (
    <section id="contact" className="py-8 sm:py-12 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 sm:mb-4 md:mb-6">
              {t('contact.getInTouch')}
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-charcoal max-w-3xl mx-auto leading-relaxed px-2">
              {t('contact.description')}
            </p>
          </div>

          {/* Contact Types */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-12 md:mb-16">
            {contactTypes.map((type, index) => (
              <Card key={index} className="p-4 sm:p-6 md:p-8 text-center hover:shadow-card transition-all duration-300 flex flex-col">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <type.icon className="text-white" size={20} />
                </div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-black mb-3 sm:mb-4">
                  {type.title}
                </h3>
                <p className="text-sm md:text-base text-charcoal mb-4 sm:mb-6 leading-relaxed flex-1">
                  {type.description}
                </p>
                <div className="mb-4 sm:mb-6">
                  <a 
                    href={`mailto:${type.email}`}
                    className="text-xs sm:text-sm md:text-base text-charcoal hover:text-black transition-colors font-medium break-all"
                  >
                    {type.email}
                  </a>
                </div>
                <Button 
                  variant="outline" 
                  className="w-full text-sm sm:text-base"
                  onClick={() => setIsMeetingFormOpen(true)}
                >
                  {type.cta}
                </Button>
              </Card>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <div className="bg-gradient-to-r from-black to-black-light p-6 sm:p-8 md:p-12 rounded-xl sm:rounded-2xl text-white">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4">
                {t('contact.ready.title')}
              </h3>
              <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto px-2">
                {t('contact.ready.description')}
              </p>
              <div className="flex justify-center">
                <Button 
                  variant="white" 
                  size="lg"
                  className="text-sm sm:text-base"
                  onClick={() => setIsMeetingFormOpen(true)}
                >
                  {t('contact.schedule')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MeetingSchedulingForm 
        open={isMeetingFormOpen} 
        onOpenChange={setIsMeetingFormOpen} 
      />
    </section>
  );
};

export default Contact;